import { ReactNode, useEffect, useState } from 'react'

import { UseTransitionProps, animated, useTransition } from '@react-spring/web'
import classNames from 'classnames'

import { CommonClose2Icon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'

import styles from './Tooltip.module.scss'

const defaultTransition = {
  from: { opacity: 0 },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
}

type Props = {
  showAlways?: boolean
  hasCloseButton?: boolean
  onClickCloseButton?: () => void
  hideTime?: number
  pinPosition?: 'top' | 'bottom'
  pinStyle?: React.CSSProperties
  isButtonTooltip?: boolean
  children: ReactNode
  nClickCloseCode?: string
  transition?: UseTransitionProps
}

const Tooltip = ({
  showAlways,
  children,
  isButtonTooltip,
  pinStyle,
  pinPosition,
  hasCloseButton,
  onClickCloseButton,
  hideTime = 2000,
  nClickCloseCode,
  transition,
}: Props) => {
  const [showTooltip, setShowTooltip] = useState(true)

  const transitions = useTransition(showTooltip, transition ? transition : defaultTransition)

  useEffect(() => {
    let timerId: undefined | number
    if (!hasCloseButton && !showAlways) {
      timerId = window.setTimeout(() => {
        setShowTooltip(false)
      }, hideTime)
    }

    return () => window.clearTimeout(timerId)
  }, [hideTime])

  const closeTooltip = () => {
    setShowTooltip(false)
    onClickCloseButton?.()
  }

  return (
    <>
      {transitions(
        (style, item) =>
          item && (
            <animated.div
              className={classNames(styles.ly_tooltip, { [styles.type_button_tooltip]: isButtonTooltip })}
              role="alert"
              style={style as any}
            >
              <div className={styles.content}>{children}</div>
              {hasCloseButton && (
                <Clickable className={styles.btn_close} onClick={closeTooltip} nClickCode={nClickCloseCode}>
                  <CommonClose2Icon className={styles.icon} aria-hidden="true" />
                  <span className="place_blind">툴팁 닫기</span>
                </Clickable>
              )}
              {pinStyle && pinPosition && (
                <span
                  className={classNames(styles.pin, styles[`type_${pinPosition}`])}
                  role="presentation"
                  style={pinStyle}
                />
              )}
            </animated.div>
          ),
      )}
    </>
  )
}

export default Tooltip
